export default {
  langs: ['pt'],
  defaultLangKey: 'pt'
}
